module.exports = __webpack_public_path__ + "static/media/Grafik nyt design 13092021.f2705144.svg";